export const dcrIntroModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 1,
		textAlign: 'center'
	},

	image: {
		width: '100%',
		aspectRatio: '461 / 250',
		borderRadius: 1,
		border: '1.5px solid var(--mui-palette-divider)'
	},

	textGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5
	},

	primaryText: {
		fontWeight: 600,
		lineHeight: 1.4
	},

	secondaryText: {
		color: 'text.secondary',
		fontSize: '0.875rem',
		lineHeight: 1.5
	}
};
